import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import * as CommonConstants from '../utils/common.constants';

@Injectable()
export class AppointmentService { 
  constructor(private http: HttpClient) {
  }
 
  saveApp(saveData): Observable<any> {
    return this.http.post(CommonConstants.env +'api/patient/appointment/create', saveData).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

 

  getAppointmentById(patientId: number): Observable<any> {
    return this.http.get(CommonConstants.env + 'api/patient/appointment/' + patientId).
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }
  

  errorHandler(error: any): void {
    throwError(error);
  };

  
}
